import type { MobxDocument } from '../firestore-mobx'
import {
  ObservableModelWithDecorators,
  emptyCollection,
  emptyModel,
} from '../firestore-mobx/model'
import {
  empty,
  type FirestorePromptRubricType,
} from '../firestore/PromptRubricType'
import type { FirebaseRepository } from './FirebaseRepository'

export class PromptRubricType extends ObservableModelWithDecorators<FirestorePromptRubricType> {
  static empty(repository: FirebaseRepository) {
    return emptyModel(repository, this, empty)
  }

  static emptyCollection(repository: FirebaseRepository) {
    return emptyCollection(repository, this, empty)
  }

  constructor(
    repository: FirebaseRepository,
    doc: MobxDocument<FirestorePromptRubricType>
  ) {
    super(repository, doc)
  }

  get title() {
    if (!this.hasData) return ''
    return this.data.title
  }

  get description() {
    if (!this.hasData) return ''
    return this.data.description
  }

  get minScore() {
    if (!this.hasData) return 0
    return this.data.minScore
  }

  get maxScore() {
    if (!this.hasData) return 0
    return this.data.maxScore
  }

  get scoreDescriptions() {
    if (!this.hasData) return []
    return this.data.scoreDescriptions
  }

  get scoreGrouping() {
    if (!this.hasData) return undefined
    return this.data.scoreGrouping ?? undefined
  }

  /** Prefillable rubric presets, in authoring order. */
  get variants() {
    if (!this.hasData) return []
    return [...this.data.variants].sort((a, b) => a.order - b.order)
  }

  get excludeSoloExperiences() {
    if (!this.hasData) return false
    return this.data.excludeSoloExperiences ?? false
  }

  /**
   * Whether a rubric of this type requires its per-instance directive. Raw
   * value — `undefined` when unset, so callers can fall back to the web app's
   * isPromptRequired() default.
   */
  get requiresRubricPrompt(): boolean | undefined {
    if (!this.hasData) return undefined
    return this.data.requiresRubricPrompt
  }
}
